import {createSvgIcon} from '../create-svg-icon';

export const SportsGolfIcon = createSvgIcon(
  [<path d="M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z" key="0" />,<circle cx="10" cy="8" r="1" key="1" />,<circle cx="14" cy="8" r="1" key="2" />,<circle cx="12" cy="6" r="1" key="3" />,<path d="M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z" key="4" />,]
, 'SportsGolfOutlined');
